export default "__VITE_ASSET__wQefUzKy__"